var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManhole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 116.333 116.333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3478",
    "data-name": "Group 3478",
    transform: "translate(-440.187 -454.667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 498.354,
    cy: 512.833,
    r: 58.167,
    fill: "#b5651d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3475",
    "data-name": "Group 3475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4119",
    "data-name": "Path 4119",
    d: "M498.354,571a58.167,58.167,0,1,1,58.166-58.167A58.233,58.233,0,0,1,498.354,571Zm0-112.335a54.169,54.169,0,1,0,54.168,54.168A54.23,54.23,0,0,0,498.354,458.665Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3476",
    "data-name": "Group 3476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4120",
    "data-name": "Path 4120",
    d: "M498.354,563.135A50.3,50.3,0,0,1,448.2,516.512l-.136-1.878,1.867-.248a1.567,1.567,0,0,0,0-3.106l-1.866-.248.136-1.878a50.288,50.288,0,0,1,100.3-.029l.163,2.237-2.331-.1a1.57,1.57,0,0,0,0,3.14l2.329-.111-.164,2.249a50.3,50.3,0,0,1-50.151,46.594Zm-46.031-45.383a46.291,46.291,0,0,0,92.031.272,5.568,5.568,0,0,1,0-10.381,46.291,46.291,0,0,0-92.031.272,5.561,5.561,0,0,1,0,9.837Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3477",
    "data-name": "Group 3477"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4121",
    "data-name": "Path 4121",
    d: "M545.873,520.424h-5.689v15.394h.647a48,48,0,0,0,5.042-14.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 5.689,
    height: 15.394,
    transform: "translate(529.81 520.424)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 15.394,
    height: 5.689,
    transform: "translate(510.429 530.464)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 15.394,
    height: 5.689,
    transform: "translate(510.429 520.089)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 5.689,
    height: 15.394,
    transform: "translate(500.753 520.424)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 5.689,
    height: 15.394,
    transform: "translate(490.378 520.424)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 15.394,
    height: 5.689,
    transform: "translate(470.997 530.464)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 15.394,
    height: 5.689,
    transform: "translate(470.997 520.089)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 5.689,
    height: 15.394,
    transform: "translate(461.322 520.424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4122",
    "data-name": "Path 4122",
    d: "M455.876,535.818h.76V520.424h-5.689v1.567A48.025,48.025,0,0,0,455.876,535.818Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4123",
    "data-name": "Path 4123",
    d: "M530.144,546.336h2.985a48.586,48.586,0,0,0,4.693-5.689h-7.678Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4124",
    "data-name": "Path 4124",
    d: "M526.157,540.981h-5.689v14.8a48.238,48.238,0,0,0,5.689-3.453Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 5.689,
    height: 15.394,
    transform: "translate(510.094 540.981)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 15.394,
    height: 5.689,
    transform: "translate(490.713 551.021)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 15.394,
    height: 5.689,
    transform: "translate(490.713 540.647)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 5.689,
    height: 15.394,
    transform: "translate(481.037 540.981)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4125",
    "data-name": "Path 4125",
    d: "M470.663,540.981v11.426a48.176,48.176,0,0,0,5.689,3.433V540.981Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4126",
    "data-name": "Path 4126",
    d: "M466.676,540.647h-7.79a48.572,48.572,0,0,0,4.692,5.689h3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4127",
    "data-name": "Path 4127",
    d: "M540.184,488.713v5.99h2.925A48.086,48.086,0,0,0,540.184,488.713Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4128",
    "data-name": "Path 4128",
    d: "M535.5,481.982q-1.148-1.38-2.39-2.673h-3.3V494.7h5.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 15.394,
    height: 5.689,
    transform: "translate(510.429 489.349)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 15.394,
    height: 5.689,
    transform: "translate(510.429 478.974)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 5.689,
    height: 15.394,
    transform: "translate(500.753 479.309)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 5.689,
    height: 15.394,
    transform: "translate(490.378 479.309)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 15.394,
    height: 5.689,
    transform: "translate(470.997 489.349)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 15.394,
    height: 5.689,
    transform: "translate(470.997 478.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4129",
    "data-name": "Path 4129",
    d: "M467.011,479.309H463.6q-1.184,1.229-2.276,2.541V494.7h5.689Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4130",
    "data-name": "Path 4130",
    d: "M453.6,494.7h3.038v-6.186A48.055,48.055,0,0,0,453.6,494.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4131",
    "data-name": "Path 4131",
    d: "M526.157,473.336a48.385,48.385,0,0,0-5.689-3.454v4.264h5.689Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4132",
    "data-name": "Path 4132",
    d: "M510.094,474.146h5.689v-6.362a47.928,47.928,0,0,0-5.689-1.812Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 15.394,
    height: 5.689,
    transform: "translate(490.713 468.791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4133",
    "data-name": "Path 4133",
    d: "M486.726,465.942a47.933,47.933,0,0,0-5.689,1.8v6.4h5.689Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4134",
    "data-name": "Path 4134",
    d: "M470.663,474.146h5.689v-4.32a48.188,48.188,0,0,0-5.689,3.434Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4135",
    "data-name": "Path 4135",
    d: "M544.331,509.906H530.144v5.689H544.11a3.567,3.567,0,0,1,.221-5.689Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4136",
    "data-name": "Path 4136",
    d: "M530.144,499.532v5.689h15.394v-2.679c-.22-1.017-.48-2.019-.763-3.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 5.689,
    height: 15.394,
    transform: "translate(520.468 499.866)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 5.689,
    height: 15.394,
    transform: "translate(510.094 499.866)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 15.394,
    height: 5.689,
    transform: "translate(490.713 509.906)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 15.394,
    height: 5.689,
    transform: "translate(490.713 499.532)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 5.689,
    height: 15.394,
    transform: "translate(481.037 499.866)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 5.689,
    height: 15.394,
    transform: "translate(470.663 499.866)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4137",
    "data-name": "Path 4137",
    d: "M451.973,515.595h14.7v-5.689h-14.94a3.544,3.544,0,0,1,.237,5.689Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4138",
    "data-name": "Path 4138",
    d: "M466.676,499.532H451.933c-.238.831-.457,1.67-.651,2.519v3.17h15.394Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManhole);
export default __webpack_public_path__ + "static/media/manhole.ad6ac023d9f0aaac54308ddaf178c690.svg";
export { ForwardRef as ReactComponent };